export default "__VITE_ASSET__CHlH9WeU__"